module.exports = __webpack_public_path__ + "static/media/daily.775e36e5.png";